import React, { useState, useEffect, useRef, useCallback } from "react";
import "./TicketPanel.css";
import "./SharedTable.css";
import API_BASE_URL from "./RestAPI.js";
import { showSuccessToast, showErrorToast } from "../constants/ToastService.js";
import { FiPaperclip, FiLink, FiChevronRight, FiChevronDown, FiRefreshCcw, FiDownload, FiTrash2, FiCheck, FiEdit2 } from "react-icons/fi";
import { GoBug } from "react-icons/go";
import { VscTypeHierarchySub } from "react-icons/vsc";
import Comment from "./Comment";
import { encryptData, decryptData } from './cryptoUtils';
import { Autocomplete, TextField, Backdrop, CircularProgress } from '@mui/material';
import { formatDateTime } from "./Common Components/CommonFunction.js";

// FiGitBranch, FiGitMerge, FiShare2, FiShare,FiCornerDownRight, FiPlusSquare,FiLayers

const TicketSidePanel = ({ closePanel, editData, trigerouterAPi }) => {
  const [ticket, setTicket] = useState(editData);
  const [showAttachmentPopup, setShowAttachmentPopup] = useState(false);
  const [showLinkPopup, setShowLinkPopup] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [linkUrl, setLinkUrl] = useState("");
  const [linkName, setLinkName] = useState("");
  const [showDetail, setshowDetail] = useState(true)
  const [comments, setComments] = useState([]);
  const [editTicketId, seteditTicketId] = useState(null);
  const [editedData, seteditedData] = useState(null);
  const [ticketStatus, setTicketStatus] = useState([])
  const [ticketTypes, setTicketTypes] = useState([])
  const [priorityType, setPriorityType] = useState([])
  const [employees, setEmployees] = useState([]);
  const panelRef = useRef(null);
  const editorRef = useRef(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [mentionQuery, setMentionQuery] = useState("");
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [cursorPos, setCursorPos] = useState({ top: 0, left: 0 });
  const [addSubComment, setAddSubComment] = useState(false);
  const [parentCommentId, setParentCommentId] = useState(null);
  const [ticketAttachments, setTicketAttachments] = useState([]);
  const [loader, setLoader] = useState(false);

  const handleKeyDown = (e) => {
    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0) return;

    const char = e.key;
    if (char === "@") {
      setShowSuggestions(true);
      setMentionQuery("");
      updateCursorPosition();
    }
  };

  const handleInput = () => {
    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0) return;

    const node = sel.anchorNode;
    const text = node?.textContent || "";
    const lastAt = text.lastIndexOf("@");

    if (lastAt >= 0) {
      const query = text.slice(lastAt + 1);
      setMentionQuery(query);

      const filtered = employees.filter((emp) =>
        emp.name.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredEmployees(filtered);
    } else {
      setShowSuggestions(false);
    }
  };

  const insertMention = (user) => {
    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0) return;

    const range = sel.getRangeAt(0);
    const container = range.startContainer;

    // Step 1: Remove the @mention query text (like "@sar")
    const text = container.textContent;
    const lastAt = text.lastIndexOf("@");
    const beforeAt = text.slice(0, lastAt);
    const afterMention = text.slice(range.startOffset); // In case cursor is in middle
    const newText = beforeAt + afterMention;

    container.textContent = newText;

    // Step 2: Move range to the end of updated text node
    const newRange = document.createRange();
    newRange.setStart(container, beforeAt.length);
    newRange.setEnd(container, beforeAt.length);
    sel.removeAllRanges();
    sel.addRange(newRange);

    // Step 3: Create <a> mention element
    const link = document.createElement("a");
    link.className = "mention";
    link.textContent = `@${user.name}`;
    link.href = `/user/${user.id}`;
    link.dataset.userId = user.id;
    link.style.color = "#4ea1f3";
    link.style.textDecoration = "none";
    link.style.marginRight = "4px";

    // Step 4: Insert the link
    newRange.insertNode(link);

    // Step 5: Add a space after the mention and collapse
    const space = document.createTextNode(" ");
    link.after(space);

    // Move cursor after the inserted space
    const finalRange = document.createRange();
    finalRange.setStartAfter(space);
    finalRange.collapse(true);
    sel.removeAllRanges();
    sel.addRange(finalRange);

    // Hide suggestions
    setShowSuggestions(false);
  };

  const updateCursorPosition = () => {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;
    const range = selection.getRangeAt(0);
    const rect = range.getBoundingClientRect();
    setCursorPos({ top: rect.top + 20, left: rect.left });
  };


  const handleFileUpload = (e) => {
    setAttachments(Array.from(e.target.files));
  };


  useEffect(() => {
    console.log("Updated attachments:", attachments);
  }, [attachments]);

  const uploadAttachments = async (ticketId) => {
    if (!attachments.length) {
      showErrorToast("Please select files to upload");
      return;
    }

    const formData = new FormData();
    formData.append("ticket_id", ticketId);

    attachments.forEach((file) => {
      formData.append("attachments", file); // raw file
    });

    try {
      const res = await fetch(
        `${API_BASE_URL}ticketing/attachements/`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: formData,
        }
      );

      if (!res.ok) {
        throw new Error("Upload failed");
      }

      const data = await res.json();

      if (data.status === "success") {
        showSuccessToast(data.message);
        setShowAttachmentPopup(false);
        setAttachments([]);
        fetchTicketAttachments(ticketId);
      } else {
        showErrorToast(data.message || "Upload failed");
      }
    } catch (err) {
      showErrorToast("Something Went Wrong");
    }
  };


  const handleShowTable = () => {
    if (showDetail === true) {
      setshowDetail(false);
    } else {
      setshowDetail(true);
    }
  }

  const handleTicketEdit = async (e) => {
    const payload = {
      short_description: e.short_description,
      assigned_to_id: e.assigned_to_id,
      company_id: 1,
      sprint_id: e.sprint_id,
      status_id: e.status_id,
      detailed_description: e.detailed_description,
      user_story: e.user_story,
      acceptance_criteria: e.acceptance_criteria,
      id: editTicketId,
      developers: e?.developers?.map((list) => ({ id: list?.id, name: list?.name })),
      qa_id: +e?.qa_id || null,
      peer_qa_id: +e?.peer_qa_id || null,
      uat_id: +e?.uat_id || null,
      dev_est_time: e?.dev_est_time || "",
      qa_est_time: e?.qa_est_time || "",
      story_points: e?.story_points || "",
      priority_id: e?.priority_id || null,
      ticket_type: e?.ticket_type || null,
    };
    let url = `${API_BASE_URL}ticketing/ticket/`;
    let method = "PUT";
    setLoader(true)
    await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setLoader(false)
          showSuccessToast(data.message);
          fetchTicketsForSprint(e.sprint_id, editTicketId);
          seteditTicketId(null);
          seteditedData(null);
        } else if (data.status === "fail") {
          setLoader(false)
          showErrorToast(data.message);
        }
      })
      .catch(() => {
        setLoader(false)
        console.log("Failed to save data");
      });
  }

  const fetchTicketsForSprint = useCallback(async (sprintId, ticketId) => {
    try {
      return fetch(`${API_BASE_URL}ticketing/ticket/?sprint_id=${sprintId}&id=${ticketId}`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            setTicket(data.data);
            trigerouterAPi(ticket.sprint_id)
          }
        })
        .catch((err) => {
          console.error(err.message);
          return [];
        });
    } catch (err) {
      console.error(err);
      showErrorToast("Failed to fetch tickets");
    }
  }, []);
  const fetchCommentsAndEmployees = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}ticketing/comments/?ticket_id=${ticket.id}`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });
      const data = await res.json();
      if (data.status === "success") {
        setComments(data.data);
      }
    } catch (err) {
      console.error(err);
      showErrorToast("Failed to fetch Comments");
    }

    try {
      const res2 = await fetch(`${API_BASE_URL}core/employee/`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });
      const data2 = await res2.json();
      if (data2.status === "success") {
        setEmployees(data2.data);
      } else {
        showErrorToast("Failed to load employees");
      }
    } catch (err) {
      console.error(err);
      showErrorToast("Failed to fetch Employees");
    }
  };

  const fetchTicketAttachments = async () => {
    try {
      const res2 = await fetch(`${API_BASE_URL}ticketing/attachements/?ticket_id=${ticket.id}`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });
      const data = await res2.json();
      if (data.status === "success") {
        setTicketAttachments(data.data);
      } else {
        showErrorToast("Failed to load attachments");
      }
    } catch (err) {
      console.error(err);
      showErrorToast("Failed to fetch attachments");
    }
  }

  const handleDownload = async (attachment) => {
    try {
      const response = await fetch(`${API_BASE_URL}ticketing/attachements/?id=${attachment.id}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });
      const data = await response.json();
      if (data.status === "success") {
        if (data.data) {
          window.open(data.data) 
        } 
      } else {
        showErrorToast("Failed to delete attachemnt");
      }    
  } 
  catch (err) {
      console.error("Download failed", err);
    }
  };

  const handleFileDelete = async (attachment) => {
    try {
      setLoader(true);
      const response = await fetch(`${API_BASE_URL}ticketing/attachements/?id=${attachment.id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });
      const data = await response.json();
      if (data.status === "success") {
        setLoader(false);
        showSuccessToast(data.message);
        fetchTicketAttachments();
      } else {
        showErrorToast("Failed to delete attachemnt");
      }
    } catch (err) {
      console.error(err);
      showErrorToast("Failed to delete Attachment");
    }
  }

  useEffect(() => {
    fetchCommentsAndEmployees();
    fetchTicketAttachments();
  }, [ticket.id]);


  useEffect(() => {
    if (editData) {
      setTicket(editData)
    }
  }, [editData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (panelRef.current && !panelRef.current.contains(event.target)) {
        closePanel(ticket.sprint_id); // this should hide the panel
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [closePanel]);

  useEffect(() => {
    if (editTicketId) {
      fetch(`${API_BASE_URL}core/status/`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            setTicketStatus(data.data);
          } else {
            showErrorToast("Failed to load employees");
          }
        })
        .catch((err) => console.error("Error fetching employees:", err));
      fetch(`${API_BASE_URL}core/priorityType/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            setPriorityType(data.data);
          } else {
            showErrorToast("Failed to load employees");
          }
        })
        .catch((err) => console.error("Error fetching employees:", err));
      fetch(`${API_BASE_URL}core/ticketType/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            setTicketTypes(data.data);
          } else {
            showErrorToast("Failed to load employees");
          }
        })
        .catch((err) => console.error("Error fetching employees:", err));
    }
  }, [editTicketId]);

  const handleCommentAdd = async (ticket) => {
    const htmlContent = editorRef.current.innerHTML;
    console.log("Submitted comment:", htmlContent);
    const payload = {
      ticket_id: ticket.id,
      comments: htmlContent,
      company_id: ticket.company_id,
      is_parent_comment: true
    }

    let url = `${API_BASE_URL}ticketing/comments/`;
    let method = "POST";

    await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        editorRef.current.innerHTML = "";
        if (data.status === "success") {
          showSuccessToast(data.message);
          fetchCommentsAndEmployees();
          // fetchTicketsForSprint(e.sprint_id, editTicketId);
        } else if (data.status === "fail") {
          showErrorToast(data.message);
        }
      })
      .catch(() => {
        console.log("Failed to save data");
      });
  }

  const handleAddSubComment = (parentId) => {
    setAddSubComment(true);
    setParentCommentId(parentId)
  }

  const handleAddReply = async (ticket, commentid) => {
    const htmlContent = editorRef.current.innerHTML;
    const payload = {
      ticket_id: ticket.id,
      comments: htmlContent,
      company_id: ticket.company_id,
      is_parent_comment: false,
      parent_comment_id: commentid
    }

    let url = `${API_BASE_URL}ticketing/comments/`;
    let method = "POST";

    await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        editorRef.current.innerHTML = "";
        if (data.status === "success") {
          showSuccessToast(data.message);
          fetchCommentsAndEmployees();
          setAddSubComment(false);
          // fetchTicketsForSprint(e.sprint_id, editTicketId);
        } else if (data.status === "fail") {
          showErrorToast(data.message);
        }
      })
      .catch(() => {
        console.log("Failed to save data");
      });
  }
  const AddTicketLinks = async (id) => {
    const payload = {
      url: linkUrl,
      url_name: linkName,
      ticket_id: id
    }

    let url = `${API_BASE_URL}ticketing/links/`;

    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          showSuccessToast(data.message);
          setShowLinkPopup(false);
          setLinkUrl("");
          setLinkName("");
          fetchTicketsForSprint(ticket.sprint_id, id);
        } else if (data.status === "fail") {
          showErrorToast(data.message);
        }
      })
      .catch(() => {
        console.log("Failed to save data");
      });
  }

  const handleDeleteLink = async (data) => {
    let url = `${API_BASE_URL}ticketing/links/?ticket_link_id=${data?.id}`;
    let method = 'DELETE'
    await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },

    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          showSuccessToast(data.message);
          fetchCommentsAndEmployees();
          setShowLinkPopup(false);
          fetchTicketsForSprint(ticket.sprint_id, ticket.id);
        } else if (data.status === "fail") {
          showErrorToast(data.message);
        }
      })
      .catch(() => {
        console.log("Failed to save data");
      });
  }

  return (
    <div ref={panelRef} className="ticket-panel">
      {/* Ticket Number */}
      {/* {ticket.ticket_type === "PARENT" ? ( */}
      <div className="outer-div" style={{ paddingTop: "10px", display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
        Ticket No: {ticket.parent_code}
        {
          editTicketId === ticket.id ? <div>
            <FiLink
              style={{ color: "white", fontSize: "35px" }}
              onClick={() => { setShowLinkPopup(true) }}
              className="edit-btn"
            />
            <FiPaperclip
              style={{ color: "white", fontSize: "35px" }}
              onClick={() => setShowAttachmentPopup(true)}
              className="edit-btn"
            />
            <FiCheck
              style={{ color: "white", fontSize: "35px" }}
              onClick={() => {
                handleTicketEdit(editedData)
              }}
              className="edit-btn"
            />
          </div> :
            <div>
              <FiLink
                style={{ color: "white", fontSize: "35px" }}
                onClick={() => { setShowLinkPopup(true) }}
                className="edit-btn"
              />
              <FiPaperclip
                style={{ color: "white", fontSize: "35px" }}
                onClick={() => setShowAttachmentPopup(true)}
                className="edit-btn"
              />
              <FiEdit2
                style={{ color: "white", fontSize: "35px" }}
                onClick={() => {
                  seteditTicketId(ticket.id);
                  seteditedData({ ...ticket });
                }}
                className="edit-btn"
              />
            </div>

        }
      </div>
      {/* ) : (
        <div className="outer-div" style={{ paddingTop: "10px" }}>
          Ticket No: {ticket.child_code}
        </div>
      )} */}


      {/* Title */}
      <h1
        className="text-areas"
        style={{ paddingTop: "10px", width: '100%' }}
      // onClick={() => {
      //   seteditTicketId(ticket.id);
      //   seteditedData({ ...ticket });
      // }}
      >
        {editTicketId === ticket.id ? (
          <>
            <input
              type="text"
              style={{ width: '100%'}}
              value={editedData.short_description}
              onChange={(e) =>
                seteditedData({
                  ...editedData,
                  short_description: e.target.value,
                })
              }
            />
            <select
              className="select"
              style={{ marginBottom: '10px'}}
              value={editedData.priority_id}
              onChange={(e) =>
                seteditedData({ ...editedData, priority_id: e.target.value })
              }
            >
              {(priorityType || []).map((status) => (
                <option
                  className="option_dropdown"
                  key={status.id}
                  value={status.id}
                >
                  {status.priority}
                </option>
              ))}
            </select>
            <select
              className="select"
              style={{ marginBottom: '10px'}}
              value={editedData.ticket_type}
              onChange={(e) =>
                seteditedData({ ...editedData, ticket_type: e.target.value })
              }
            >
                <option className="option_dropdown" key='Epic' value='Epic'> Epic </option>
                <option className="option_dropdown" key='Story' value='Story'> Story </option>
                <option className="option_dropdown" key='Bug' value='Bug'> Bug </option>
            </select>
          </>
        ) : ticket.short_description ? (
          ticket.short_description
        ) : (
          "-"
        )}
      </h1>

      {editTicketId !== ticket.id ?
        <>
          <h5>{`Priority : ${ticket?.priority_name}`}</h5>
          <h5 style={{ marginTop: "0.3vw" }}>{`Tic Type : ${ticket?.ticket_type_str}`}</h5>
        </> : null}


      {/* Attachment Icon */}
      <div className="outer-div">
        {/* Attachment Modal */}
        {showAttachmentPopup && (
          <div className="outer-div" style={{ paddingTop: "10px" }}>
            <h3 className="font-semibold mb-2">Attachments</h3>

            <ul className="list-disc list-inside text-sm">
              {attachments.map((file, index) => (
                <li key={index}>{file.name}</li>
              ))}
            </ul>

            <input
              type="file"
              multiple
              onChange={handleFileUpload}
              style={{ marginTop: "10px" }}
            />

            <button
              className="cancel-btn"
              onClick={() => uploadAttachments(ticket.id, attachments)}
            >
              Upload
            </button>

            <button
              className="cancel-btn"
              onClick={() => setShowAttachmentPopup(false)}
            >
              Close
            </button>
          </div>
        )}


        {showLinkPopup && (
          <div className="outer-div" style={{ paddingTop: "10px" }}>
            <label htmlFor="current_link" className="required">Link URL</label>
            <input
              type="text"
              id="current_link"
              style={{ width: "100%" }}
              value={linkUrl}
              onChange={(e) => setLinkUrl(e.target.value)}
            />
            <label htmlFor="current_link_name" className="required">Link Label</label>
            <input
              type="text"
              id="current_link_name"
              style={{ width: "100%" }}
              value={linkName}
              onChange={(e) => setLinkName(e.target.value)}
            />
            <button disabled={!linkUrl} className="cancel-btn" onClick={() => {
              if (!linkUrl) {
                showErrorToast("Enter the Link ")
              } else if (!linkName) {
                showErrorToast("Enter the Link Name")
              } else {
                AddTicketLinks(ticket.id)
              }
            }}>add</button>
            <button
              className="cancel-btn"
              onClick={() => {
                setShowLinkPopup(false)
                setLinkUrl("");
                setLinkName("");
              }}
            >
              Close
            </button>
          </div>
        )}
        <br />
        <div>
          <div className="title_header">Status</div>
          {editTicketId === ticket.id ? (
            <select
              className="select"
              value={editedData.status_id}
              onChange={(e) =>
                seteditedData({ ...editedData, status_id: e.target.value })
              }
            >
              {(ticketStatus || []).map((status) => (
                <option
                  className="option_dropdown"
                  key={status.id}
                  value={status.id}
                >
                  {status.ticket_status}
                </option>
              ))}
            </select>
          ) :
            <div className="tic_contents" style={{ whiteSpace: "pre-line" }}>
              {ticket?.ticket_status || "-"}
            </div>
          }
        </div>
      </div>

      <div className="text-areas" style={{ paddingTop: "10px", width: "100%" }}>
        <div className="title_header">Description</div>
        <div
          className="text-areas"
          style={{
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {editTicketId === ticket.id ? (
            <input
              type="text"
              style={{ width: "100%" }}
              value={editedData.detailed_description}
              onChange={(e) =>
                seteditedData({
                  ...editedData,
                  detailed_description: e.target.value,
                })
              }
            />
          ) :
            <div className="tic_contents" style={{ whiteSpace: "pre-line" }}>
              {ticket?.detailed_description || "-"}
            </div>}
        </div>
      </div>

      {/* User Story */}
      <div className="text-areas" style={{ width: "100%" }}>
        <div className="title_header">User Story</div>
        <div
          className="text-areas"
          style={{
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {editTicketId === ticket.id ? (
            <textarea
              rows={3}
              type="text"
              style={{ width: "100%" }}
              value={editedData.user_story}
              onChange={(e) =>
                seteditedData({
                  ...editedData,
                  user_story: e.target.value,
                })
              }
            />
          ) :
            <div className="tic_contents" style={{ whiteSpace: "pre-line" }}>
              {ticket?.user_story || "-"}
            </div>}
        </div>
      </div>

      {/* Acceptance Criteria */}
      <div className="text-areas" style={{ paddingTop: "10px", width: "100%" }}>
        <div className="title_header">Acceptance Criteria</div>
        <div
          className="text-areas"
          style={{
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {editTicketId === ticket.id ? (
            <textarea
              rows={3}
              type="text"
              style={{ width: "100%" }}
              value={editedData.acceptance_criteria}
              onChange={(e) =>
                seteditedData({
                  ...editedData,
                  acceptance_criteria: e.target.value,
                })
              }
            />
          ) :
            <div className="tic_contents" style={{ whiteSpace: "pre-line" }}>
              {ticket.acceptance_criteria || "-"}
            </div>}
        </div>
      </div>



      <div className="outer-div" style={{ paddingTop: "10px" }}>
        <h3 className="font-semibold mb-2">Attachments</h3>
        <ul className="text-sm space-y-1">
          {ticketAttachments.length > 0 ? 
            (ticketAttachments.map((attachment) => (
              <li key={attachment.id} className="flex items-center justify-between">
                {attachment.attachment_key && (
                  <span>{attachment.filename}
                    <FiDownload
                      onClick={() => handleDownload(attachment)}
                      className="download-btn"
                    />
                    <FiTrash2
                      onClick={() => handleFileDelete(attachment)}
                      className="download-btn"
                    />
                  </span>
                )}
              </li>
            ))
          ) : <h4 style={{ fontSize: '12px', fontWeight: 'normal' }}>No Attachments</h4>}
        </ul>
      </div>

      <div className="outer-div" style={{ paddingTop: "10px" }}>
        <h3 className="font-semibold mb-2">Links</h3>
        <ul className="text-sm space-y-1">
          {ticket?.links?.length > 0 ?
          (ticket?.links.map((item) => (
            <li key={item.id} className="flex items-center justify-between">
              <a href={item.url} target="_blank" style={{ color: "white" }}>
                {item.url_name}
              </a>
              <span>
                <FiTrash2
                  onClick={() => handleDeleteLink(item)}
                  className="download-btn"
                />
              </span>
            </li>
          ))) : <h4 style={{ fontSize: '12px', fontWeight: 'normal' }}>No Links</h4>}
        </ul>
      </div>


      {/* Ticket Info Table */}
      <div className="outer-div" style={{ paddingTop: "10px" }}>
        <table className="fd-table fd-table--nested">
          <thead>
            <th style={{ fontSize: "20px" }}>Details</th>
            {showDetail === true ? (
              <th style={{ textAlign: "right" }}>
                <FiChevronDown size={18} onClick={() => handleShowTable()} />
              </th>
            ) : (
              <th style={{ textAlign: "right" }}>
                <FiChevronRight size={20} onClick={() => handleShowTable()} />
              </th>
            )}
          </thead>
        </table>

        {showDetail && (
          <table className="fd-table fd-table--nested">
            <tbody>
              <tr>
                <th style={{padding: '5px 0px'}}>Assignee</th>
                <td>{ticket.assignee_name}</td>
              </tr>
              <tr>
                <th style={{ padding: '5px 0px'}}>Developers</th>
                <td>{editTicketId === ticket.id ? <div>
                  <Autocomplete
                    multiple
                    getOptionLabel={(option) => (typeof option === "string" ? option : option?.name || "")}
                    disablePortal
                    options={employees}
                    sx={{ width: 300, backgroundColor: 'GrayText', margin: '5px' }}
                    renderInput={(params) => <TextField
                      {...params}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#121212",
                          color: "#fff",
                          "& fieldset": { borderColor: "#555" },
                          "&:hover fieldset": { borderColor: "#888" },
                          "&.Mui-focused fieldset": { borderColor: "#1976d2" },
                        },
                        "& .MuiInputLabel-root": { color: "#bbb" },
                        "& .MuiSvgIcon-root": { color: "#fff" },
                        "& .MuiChip-root": {
                          backgroundColor: "#1e1e1e",
                          color: "#fff",
                          "& .MuiChip-deleteIcon": {
                            color: "#fff",
                            "&:hover": {
                              color: "#ccc", // optional hover lighter
                            },
                          },
                        },
                      }}
                    />}
                    value={editedData.developers || []}
                    onChange={(e, newvalue) => {
                      seteditedData({ ...editedData, developers: newvalue })
                    }}
                  />
                </div> : ticket.developers?.length ? ticket.developers.map(e => e.name).join(', ') : "-"}</td>
              </tr>
              <tr>
                <th style={{ padding: '5px 0px'}}>QA</th>
                <td>{editTicketId === ticket.id ? <div>
                  <select
                    className='select'
                    style={{ margin: '5px' }}
                    value={editedData.qa_id}
                    onChange={(e) =>
                      seteditedData({ ...editedData, qa_id: e.target.value })
                    }>
                    <option className='option_dropdown' value="">QA</option>
                    {(employees || []).map((employee) => (
                      <option className='option_dropdown' key={employee.id} value={employee.id}>
                        {employee.name}
                      </option>
                    ))}
                  </select>
                </div> : ticket.qa_name}</td>
              </tr>
              <tr>
                <th style={{ padding: '5px 0px'}}>Peer QA</th>
                <td>{editTicketId === ticket.id ? <div>
                  <select
                    className='select'
                    style={{ margin: '5px' }}
                    value={editedData.peer_qa_id}
                    onChange={(e) =>
                      seteditedData({ ...editedData, peer_qa_id: e.target.value })
                    }
                  >
                    <option className='option_dropdown' value="">Peer QA</option>
                    {(employees || []).map((employee) => (
                      <option className='option_dropdown' key={employee.id} value={employee.id}>
                        {employee.name}
                      </option>
                    ))}
                  </select>
                </div> : ticket.peer_qa_name}</td>
              </tr>
              <tr>
                <th style={{ padding: '5px 0px'}}>UAT</th>
                <td>{editTicketId === ticket.id ? <div>
                  <select
                    className='select'
                    style={{ margin: '5px' }}
                    value={editedData.uat_id}
                    onChange={(e) =>
                      seteditedData({ ...editedData, uat_id: e.target.value })
                    }>
                    <option className='option_dropdown' value="">UAT</option>
                    {(employees || []).map((employee) => (
                      <option className='option_dropdown' key={employee.id} value={employee.id}>
                        {employee.name}
                      </option>
                    ))}
                  </select>
                </div> : ticket.uat_name}</td>
              </tr>
              <tr>
                <th style={{ padding: '5px 0px'}}> Dev Est. Time</th>
                <td>{editTicketId === ticket.id ? <div>
                  <input
                    type="text"
                    style={{ width: "100%", margin: '5px' }}
                    value={editedData.dev_est_time}
                    onChange={(e) => {
                      const value = e.target.value;
                      const numberRegex = /^(?:[1-9]|[1-5][0-9]|60)$/;

                      if (value === "" || numberRegex.test(value)) {  // allow empty input too
                        seteditedData({
                          ...editedData,
                          dev_est_time: value,
                        });
                      }
                    }}
                  />
                </div> : ticket.dev_est_time}</td>
              </tr>
              <tr>
                <th style={{ padding: '5px 0px'}}> QA Est. Time</th>
                <td>{editTicketId === ticket.id ? <div>
                  <input
                    type="text"
                    style={{ width: "100%", margin: '5px' }}
                    value={editedData.qa_est_time || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      const numberRegex = /^(?:[1-9]|[1-5][0-9]|60)$/;

                      if (value === "" || numberRegex.test(value)) {  // allow empty input too
                        seteditedData({
                          ...editedData,
                          qa_est_time: value,
                        });
                      }
                    }}
                  />
                </div> : ticket.qa_est_time}</td>
                {/* <td>{ticket.estimated_time}</td> */}
              </tr>
              <tr>
                <th style={{ padding: '5px 0px'}}>Story Points</th>
                <td>{editTicketId === ticket.id ? <div>
                  <select
                    className='select'
                    style={{ margin: '5px' }}
                    value={editedData.story_points}
                    onChange={(e) =>
                      seteditedData({ ...editedData, story_points: e.target.value })
                    }>
                    <option className='option_dropdown' value="">Story Points</option>
                    <option className='option_dropdown' value="1">1</option>
                    <option className='option_dropdown' value="2">2</option>
                    <option className='option_dropdown' value="3">3</option>
                    <option className='option_dropdown' value="5">5</option>
                    <option className='option_dropdown' value="8">8</option>
                    <option className='option_dropdown' value="13">13</option>
                  </select>
                </div> : ticket.story_points}</td>
                {/* <td>{ticket.story_points}</td> */}
              </tr>
            </tbody>
          </table>
        )}
      </div>

      {/* comment section */}
      <br></br>
      <h2>Comments</h2><br></br>
      <div style={{ position: "relative" }}>
        {comments.map((comment) => (
          <React.Fragment key={comment.id || comment.created_at}>
            <Comment
              time={comment.time_ago}
              comment={comment}
              employeeId={comment.commented_by_id}
            />

            {comment.sub_comments && comment.sub_comments.length > 0 &&
              comment.sub_comments.map((sub_comment) => (
                <Comment
                  key={sub_comment.id || sub_comment.created_at}
                  time={sub_comment.time_ago}
                  comment={sub_comment}
                  employeeId={sub_comment.commented_by_id}
                />
              ))
            }
            <div
              style={{ marginLeft: '70px', marginBottom: '10px' }}
            >
              {(addSubComment && comment.id === parentCommentId) ? (
                <>
                  <div
                    ref={editorRef}
                    className="comment-box"
                    contentEditable
                    onKeyDown={handleKeyDown}
                    onInput={handleInput}
                  />
                  <button className="save-btn" onClick={() => handleAddReply(ticket, comment.id)}>
                    Reply
                  </button>
                  <button className="save-btn" onClick={() => setAddSubComment(false)}>
                    Close
                  </button>

                  {showSuggestions && filteredEmployees.length > 0 && (
                    <div className="suggestions-box">
                      {filteredEmployees.map((user) => (
                        <div
                          key={user.id}
                          onClick={() => insertMention(user)}
                          style={{
                            padding: "6px 10px",
                            cursor: "pointer",
                            color: "#fff",
                          }}
                          onMouseDown={(e) => e.preventDefault()} // prevent blur on click
                        >
                          {user.name}
                        </div>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <span onClick={() => handleAddSubComment(comment.id)}>
                  Write a reply...
                </span>
              )}

            </div>
          </React.Fragment>
        ))}

        <div
          ref={editorRef}
          className="comment-box"
          contentEditable
          onKeyDown={handleKeyDown}
          onInput={handleInput}
        />

        {showSuggestions && filteredEmployees.length > 0 && (
          <div
            className="suggestions-box"
          >
            {filteredEmployees.map((user) => (
              <div
                key={user.id}
                onClick={() => insertMention(user)}
                style={{
                  padding: "6px 10px",
                  cursor: "pointer",
                  color: "#fff",
                }}
                onMouseDown={(e) => e.preventDefault()} // prevent blur on click
              >
                {user.name}
              </div>
            ))}
          </div>
        )}
      </div>
      <button className="save-btn" onClick={() => handleCommentAdd(ticket)}>
        Add Comment
      </button>

      <>
        <hr></hr>
        <h2 style={{ marginTop: "1vw" }}>History</h2><br></br>
        <table className="fd-table fd-table--nested">
          <thead>
            <tr>
              <th>Changed By</th>
              <th>From Status</th>
              <th>To Status</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody>
            {ticket?.status_log?.length > 0 ? (
              ticket?.status_log.map((ticket) => (
                <>
                  <tr>
                    <td>{ticket.changed_by ? ticket.changed_by : '-'}</td>
                    <td>{ticket.from_status ? ticket.from_status : '-'}</td>
                    <td>{ticket.to_status ? ticket.to_status : '-'}</td>
                    <td>{ticket.changed_date ? formatDateTime(ticket.changed_date) : '-'}</td>
                  </tr>
                </>
              ))
            ) : (
              <tr>
                <td colSpan="6">No History available</td>
              </tr>
            )}
          </tbody>
        </table>
      </>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default TicketSidePanel;